var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReversedTrapezoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 108,
    viewBox: "0 0 120 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1313_2383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M108 108L12 108L-1.70711e-05 2.86134e-06L120 -7.62939e-06L108 108Z",
    fill: "url(#paint0_linear_1313_2383)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1313_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M108 108L12 108L-1.70711e-05 2.86134e-06L120 -7.62939e-06L108 108Z",
    fill: "#92C34D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1313_2383",
    x1: 118.668,
    y1: 110.625,
    x2: 118.668,
    y2: -6.71177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8A89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversedTrapezoid);
export default __webpack_public_path__ + "static/media/reversed-trapezoid.c38e0bae.svg";
export { ForwardRef as ReactComponent };